import { Auth } from 'aws-amplify';

export const AuthSignOut = () => Auth.signOut();
